// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
import type MacIcons from './MacIcons';

export type MacIconsSubset = { [icon in MacIcons]: string };

export let MacIconsDefinitions: MacIconsSubset = {
    CheckboxComposite: '\ue73a',
    Clock: '\ue917',
    Contact: '\ue77b',
    Delete: '\ue74d',
    Door: '\ueb75',
    Down: '\ue74b',
    EaseOfAccess: '\ue776',
    Edit: '\ue70f',
    EMI: '\ue731',
    FabricMovetoFolder: '\uf0a5',
    Globe: '\ue774',
    Label: '\ue932',
    MapDirections: '\ue816',
    MapPin: '\ue707',
    Phone: '\ue717',
    Play: '\ue768',
    POI: '\uecaf',
    RightDoubleQuote: '\ue9b1',
    TVMonitor: '\ue7f4',
    Up: '\ue74a',
    Video: '\ue714',
    Volume2: '\ue994',
    Warning: '\ue7ba',
};

export default {
    fontFileName: 'macIcons',
    icons: MacIconsDefinitions,
};
